import {AggregationType, ChartOutput, PartialChartQuery} from 'entities/chart';

export interface ChartFooterData {
    total?: number | string;
    totalComparable?: number | null;
    trendValue?: string;
    queryDuration?: string;
    showTrend?: boolean;
    hideTotal?: boolean;
}

const metricTotalOutputs = new Set<string>([
    ChartOutput.Terms,
    ChartOutput.MetricTimeline,
    ChartOutput.TermsMetric,
    ChartOutput.PivotTerms,
]);

export function getFooterAggregationType(chartQuery: PartialChartQuery): AggregationType | undefined {
    if (chartQuery.output === ChartOutput.MetricTimeline) {
        return chartQuery.metric_timeline_type;
    }

    const hasMetricAggregationField = !!chartQuery.metric_aggregations_aggs_item
        && chartQuery.metric_aggregations_aggs_item !== '-';

    return hasMetricAggregationField ? chartQuery.metric_aggregations_type : undefined;
}

export function shouldHideChartTotal(
    chartQueryOutput: ChartOutput | string | undefined,
    aggregationType?: AggregationType | string,
): boolean {
    return !!chartQueryOutput
        && metricTotalOutputs.has(chartQueryOutput)
        && !!aggregationType
        && aggregationType !== AggregationType.Count;
}
